/**
 * Created by user on 2020/5/29.
 */

import safe from './table_tw2cn.debug.safe';
import unsafe from './table_tw2cn.debug.unsafe';
import { IStaticDebugJSON } from '../types';

export = {
	safe,
	unsafe,
} as IStaticDebugJSON
